import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  uz_latin: {
    translation: {

      mainPage: {
        hello: "Salom",
        today: "Bugun",
        whereIsGas: "Gaz Qayerda?",
        book: "Bron Qilish",
        yourQueue: "Navbatingiz",
        balance: "Balans",
        notifications: "Bildirishnomalar",
        activeDelivery: "Faol yetkazish",
        gasDelivering: "GAZ YETKAZILMOQDA",
        viewQueue: "Navbatni ko'rish"
      },
      premiumPanel: {
        title: "SmartGaz",
        premium: "Premium",
        subtitle: "Yana-da ko'proq imkoniyatlar va qulayliklarga ega bo'ling",
        fastQueue: "Tezkor Navbat",
        fastQueueDesc: "Navbatda doim birinchilardan bo'ling va vaqtingizni tejang.",
        discounts: "Maxsus Chegirmalar",
        discountsDesc: "Har bir ballon uchun 5% gacha keshbek va chegirmalar.",
        support: "24/7 Qo'llab-quvvatlash",
        supportDesc: "Siz uchun alohida menejer va tezkor yordam xizmati.",
        statusPremium: "Siz Premium a'zosiz",
        statusNotPremium: "Hoziroq ulaning",
        activePremium: "Barcha premium imkoniyatlar siz uchun faol",
        pricePremium: "Atigi 25 000 so'm / oyiga",
        btnActive: "FAOL",
        btnActivate: "FAOLLASHTIRISH",
        success: "SmartGaz Premium muvaffaqiyatli faollashtirildi!",
        alreadyActive: "Sizda allaqachon Premium status faol!",
        error: "Faollashtirishda xatolik yuz berdi",
        insufficientBalance: "Balans yetarli emas yoki boshqa xatolik"
      },
      smsCode: {
        title: "Parolni tiklash",
        emailSubtitle: "Email manzilingizni kiriting",
        sendCode: "Kod yuborish",
        verifyCode: "Kodni tasdiqlang",
        resend: "Qayta yuborish",
        newPasswordTitle: "Yangi parol",
        newPasswordSubtitle: "Kuchli parol o'rnating",
        newPassword: "Yangi parol",
        confirmPassword: "Parolni tasdiqlang",
        passwordsMismatch: "Parollar mos kelmaydi",
        save: "Saqlash",
        backToLogin: "Kirishga qaytish"
      },
      landing: {
        services: "Xizmatlar",
        howItWorks: "Qanday ishlaydi?",
        mobileApp: "Mobil ilova",
        login: "Kirish",
        newLevelService: "Yangi darajadagi xizmat",
        heroTitle: "Gaz navbati endi telefoningizda",
        heroTitlePrefix: "Gaz navbati endi",
        heroTitleHighlight: "telefoningizda",
        heroSubtitle: "SmartGaz orqali suyultirilgan gaz ballonlariga navbatga turing, balansingizni nazorat qiling va yetkazib berish vaqtini kuzatib boring.",
        joinQueue: "Navbatga turish",
        downloadApp: "Ilovani yuklash",
        queueArrived: "Navbat keldi",
        cylinderReady: "Balloningiz tayyor!",
        threeSteps: "3 oddiy qadam",
        stepsSubtitle: "SmartGaz tizimidan foydalanish juda oson va qulay.",
        step1Title: "Ro'yxatdan o'ting",
        step1Desc: "Telefon raqamingiz orqali tizimga kiring.",
        step2Title: "Navbatga yoziling",
        step2Desc: "Bir tugma orqali elektron navbatga kiring.",
        step3Title: "Ballonni qabul qiling",
        step3Desc: "Navbatingiz kelganda gaz balloningizni kutib oling.",
        features: {
          realtime: "Real vaqtda",
          easyPayment: "Oson to'lov",
          history: "Tarix",
          support: "24/7 Yordam"
        },
        cabinetFeatures: "Shaxsiy kabinet imkoniyatlari",
        cabinetFeature1: "Gaz ballonining oxirgi sanasini kuzatish",
        cabinetFeature2: "Mahalla grafiklarini ko'rish",
        cabinetFeature3: "Tezkor bildirishnomalar",
        pricing: {
          title: "Narxlar",
          subtitle: "O'zingizga mos ta'rifni tanlang.",
          free: "Bepul (Free)",
          freeDesc: "Asosiy imkoniyatlardan foydalanish uchun",
          freePrice: "0 so'm",
          freeFeat1: "Elektron navbatga turish",
          freeFeat2: "Asosiy bildirishnomalar",
          freeFeat3: "Profil sozlamalari",
          freeBtn: "Google orqali boshlash",
          popular: "Eng mashhur",
          premium: "Premium",
          premiumDesc: "Barcha qulayliklar va ustuvorliklar",
          premiumPrice: "15 000 so'm/oy",
          premiumFeat1: "Tezkor va birinchi navbat",
          premiumFeat2: "24/7 ustuvor yordam",
          premiumFeat3: "Eksklyuziv chegirmalar",
          premiumFeat4: "Batafsil tarix va statistika",
          premiumBtn: "Premiumga o'tish",
          perMonth: "oy"
        },
        download: {
          title: "Ilovani yuklab oling",
          subtitle: "Barcha xizmatlar endi bir qo'l masofasida.",
          appStore: "Download on the App Store",
          googlePlay: "Get it on Google Play",
          ticket: "Navbat #12"
        },
        footer: {
          platform: "Raqamlashtirish platformasi.",
          servicesTitle: "Xizmatlar",
          onlineQueue: "Onlayn Navbat",
          prices: "Narxlar",
          contactTitle: "Bog'lanish"
        }
      },

      nav: {
        main: "Asosiy",
        payment: "To'lovlar",
        queue: "Navbat",
        notifications: "Xabarlar",
        dashboard: "Boshqaruv",
        statistics: "Statistika",
        users: "Foydalanuvchilar",
        trucks: "Yuk mashinalari",
        payments: "To'lovlar",
        cylinders: "Ballonlar",
        routes: "Yo'nalishlar",
        tracking: "Tracking",
        orders: "Buyurtmalar",
        premium: "Premium",
        adminPanel: "Admin panel",
      },
      languageLabel: "Tilni almashtirish",
      main: {
        welcome: "Xush kelibsiz,",
        subtitle: "Barcha xizmatlar va ma'lumotlar bir joyda.",
        today: "Bugun",
        queueStatus: "Navbat holati",
        inQueueStatus: "Navbatda",
        yourPosition: "Sizning o'rningiz",
        minutesWait: "daqiqa kutilmoqda",
        leaveQueue: "Navbatdan chiqish",
        leaveConfirm: "Navbatdan chiqishni tasdiqlaysizmi?",
        queueJoinSuccess: "Navbatga muvaffaqiyatli qo'shildingiz!",
        queueLeaveSuccess: "Navbatdan chiqdingiz",
        totalInQueue: "Jami navbatda",
        people: "kishi",
        notInQueue: "Navbatda",
        notInQueueSuffix: "emassiz",
        queueCta: "Gaz balloniga buyurtma bering va navbatga turing",
        joinQueue: "Navbatga turish",
        orders: "Buyurtmalar",
        recentOrders: "So'nggi buyurtmalar",
        noOrders: "Hali buyurtmalar yo'q",
        firstOrder: "Birinchi buyurtma",
        orderType: "Ballon buyurtmasi",
        recent: "So'nggi harakatlar",
        seeAll: "Barchasi",
        queueAction: "Navbatga turish",
        chiptaRaqami: "Chipta #12",
        myOrders: "Buyurtmalarim"
      },
      orderStatus: {
        PENDING: "Kutilmoqda",
        CONFIRMED: "Tasdiqlangan",
        PREPARING: "Tayyorlanmoqda",
        ON_WAY: "Yo'lda",
        DELIVERED: "Yetkazildi",
        CANCELLED: "Bekor qilingan",
      },
      queuePage: {
        title: "Navbat",
        subtitle: "Real vaqt rejimida navbatingizni kuzatib boring",
        current: "Hozirgi holat",
        yourTurn: "Sizning navbatingiz",
        yourPosition: "Sizning o'rningiz",
        left: "Oldingizda",
        eta: "Taxminiy vaqt",
        estimatedTime: "Taxminiy vaqt",
        etaValue: "~20 daqiqa",
        peopleCount: "5 kishi",
        progress: "Navbat rivoji",
        ready: "Sizga yaqin qoldi, tayyor turing!",
        refresh: "Yangilash",
        cancel: "Bekor qilish",
        leave: "Navbatni tark etish",
        join: "Navbatga turish",
        premium: "Premium tez navbat",
        helpText: "Savollaringiz bormi?",
        helpLink: "Yordam bo'limi",
        minutes: "daqiqa",
        currentStatus: "Hozirgi holat",
        orderStatus: "Buyurtma holati",
        listTitle: "Navbatdagi foydalanuvchilar",
        peopleWaiting: "kishi kutilmoqda",
        listEmpty: "Hozircha navbatda hech kim yo'q",
        next: "Keyingi",
        routeInfo: "Marshrut: {{status}} \u00b7 {{count}} mahalla",
        status: {
          active: "Faol",
        },
        messages: {
          joined: "Navbatga muvaffaqiyatli qo'shildingiz!",
          left: "Navbatdan chiqdingiz",
        },
        emptyState: {
          title: "Navbatda emassiz",
          subtitle: "Buyurtma berish orqali navbatga turishingiz mumkin"
        },
        steps: {
          created: { label: "Buyurtma berildi", sub: "So'rov qabul qilindi" },
          confirmed: { label: "Tasdiqlandi", sub: "Operator tasdiqladi" },
          preparing: { label: "Tayyorlanmoqda", sub: "Ballon tayyorlanmoqda" },
          onWay: { label: "Yo'lda", sub: "Kuryer yo'lga chiqdi" },
          delivered: { label: "Yetkazildi", sub: "Buyurtma yakunlandi" },
        }
      },
      tracking: {
        title: "Kuzatish",
        subtitle: "Ballon yetkazilishini real vaqtda kuzating",
        driver: "Haydovchi",
        vehicle: "Mashina",
        status: "Holat",
        eta: "Yetib kelish",
        call: "Qo'ng'iroq",
        location: "Manzil",
        callDriver: "Haydovchiga qo'ng'iroq",
        noActiveRoute: "Hozircha faol kuzatuv yo'q",
        info: {
          orderId: "Buyurtma ID",
          estimatedTime: "Taxminiy vaqt",
          distance: "Masofa",
        }
      },
      support: {
        title: "Yordam",
        subtitle: "Muammolaringizni hal qilish uchun markaz",
        sos: {
          title: "SOS",
          subtitle: "Favqulodda vaziyatlarda tezkor xabar bering",
          desc: "Xavfli vaziyat yoki gaz sizib chiqishi aniqlanganda SOS tugmasini bosing.",
          button: "SOS YUBORISH",
          confirm: "SOS yuborishni tasdiqlaysizmi?",
          success: "SOS xabari yuborildi. Tez orada siz bilan bog'lanamiz.",
          error: "SOS yuborishda xatolik yuz berdi",
        },
        faq: {
          title: "Ko'p so'raladigan savollar",
          delivery: {
            q: "Navbatga qanday turish mumkin?",
            a: "Asosiy sahifadagi 'Navbatga turish' tugmasini bosing."
          },
          debt: {
            q: "To'lov qanday amalga oshiriladi?",
            a: "To'lovlar bo'limida CLICK, Payme yoki karta orqali to'lashingiz mumkin."
          },
          quality: {
            q: "Yetkazib berish qancha vaqt oladi?",
            a: "Odatda navbatingizga qarab 30 daqiqadan 2 soatgacha."
          },
        },
        channels: {
          title: "Bog'lanish kanallari",
          chat: { title: "Onlayn Chat", desc: "Operator bilan bog'lanish" },
          call: { title: "Call Center", desc: "+998 71 200 00 00" },
          complaint: { title: "Shikoyatlar", desc: "Sifat nazorati" },
          email: { title: "Email", desc: "info@smartgaz.uz" },
        }
      },
      notifications: {
        title: "Xabarlar",
        subtitle: "Ballar bildirishnomalar va yangiliklar",
        unread: "o'qilmagan",
        markAllRead: "Barchasini o'qildi deb belgilash",
        empty: "Hali xabarlar yo'q",
        noUnread: "Barcha xabarlar o'qilgan",
        newOrder: "Yangi buyurtma qabul qilindi!",
        noUnreadItems: "O'qilmagan xabar yo'q",
        emptyHint: "Yangi xabarlar shu yerda ko'rinadi",
      },
      dashboard: {
        title: "Boshqaruv Paneli",
        subtitle: "SmartGaz tizimi real-vaqt monitoringi",
        createRoute: "Marshrut Yaratish",
        todayOrders: "Bugungi Buyurtmalar",
        activeDrivers: "Faol Haydovchilar",
        pendingOrders: "Navbatdagilar",
        todayRevenue: "Bugungi Daromad",
        weeklyRevenue: "Haftalik Daromad",
        weeklyOrders: "Haftalik Buyurtmalar",
        statisticsSubtitle: "Tizim ko'rsatkichlari va grafiklar",
        last7Days: "Oxirgi 7 kun",
        cylindersSold: "Sotilgan Ballonlar",
        volume: "Hajm",
        liveMonitoring: "Jonli Monitoring",
        activeFleet: "faol marshrut",
        activeFleetList: "Faol Marshrutlar",
        noActiveFleet: "Hozircha faol marshrutlar yo'q",
        lastCoords: "OXIRGI KOORD",
        quantity: "Miqdor",
        time: "Vaqt",
        allRoutes: "Barcha Marshrutlar",
        activateRoute: "Faollashtirish",
        completeRoute: "Yakunlash",
        routeActivated: "Marshrut faollashtirildi",
        routeCompleted: "Marshrut yakunlandi",
        userManagement: "Foydalanuvchilar boshqaruvi",
        user: "Foydalanuvchi",
        role: "Rol",
        balance: "Balans",
        status: "Status",
        actions: "Amallar",
        active: "Faol",
        blocked: "Bloklangan",
        enterNewBalance: "Yangi balansni kiriting:",
        balanceUpdated: "Balans yangilandi",
        userActivated: "Foydalanuvchi faollashtirildi",
        userBlocked: "Foydalanuvchi bloklandi",
        errorLoadingUsers: "Foydalanuvchilarni yuklashda xatolik",
        userInfoUpdated: "Foydalanuvchi ma'lumotlari yangilandi",
        quickSearch: "Tezkor qidiruv...",
        updateBalanceTitle: "Balansni yangilash",
        newBalanceAmount: "Yangi balans miqdori (UZS)",
        totalUsers: "Jami foydalanuvchilar",
        searchPlaceholder: "Qidirish...",
        lastSeen: "Oxirgi faollik",
        paymentManagement: "To'lovlarni boshqarish",
        totalTransactions: "Jami tranzaksiyalar",
        searchPayments: "To'lovlarni qidirish...",
        date: "Sana",
        amount: "Summa",
        type: "Turi",
        reason: "Sabab",
        queueManagement: "Navbatni boshqarish",
        totalInQueue: "Navbatda jami",
        searchQueue: "Navbatdan qidirish...",
        orderID: "Buyurtma ID",
        cylinders: "Ballonlar",
        totalPrice: "Umumiy narx",
        cylinderManagement: "Ballonlarni boshqarish",
        totalCylinders: "Jami ballonlar",
        searchCylinders: "Ballonlarni qidirish...",
        cylinderSerial: "Ballon seriyasi",
        capacity: "Sig'imi",
        currentUser: "Joriy foydalanuvchi",
        lastFilled: "Oxirgi to'ldirilgan",
        trucksManagement: "Transport parki",
        registeredTrucks: "Ro'yxatdagi transportlar",
        addTruck: "Yangi transport",
        routesManagement: "Yo'nalishlar boshqaruvi",
        activeRoutes: "Faol yo'nalishlar",
        newRoute: "Yangi yo'nalish",
      },
      driverDashboard: {
        role: "Haydovchi paneli",
        gpsActive: "GPS faol",
        gpsInactive: "GPS o'chiq",
        titlePrefix: "Haydovchi",
        titleSuffix: "Paneli",
        subtitle: "Marshrut boshqaruvi",
        startRoute: "Yo'lga Chiqdim",
        gpsStop: "GPS To'xtatish",
        gpsStart: "GPS Yoqish",
        gasFinished: "Gaz Tugadi",
        gasFinishedToast: "Gaz tugagani haqida xabar yuborildi",
        finishRoute: "Yakunlash",
        customerQueue: "Mijozlar Navbati",
        count: "{{count}} ta",
        priority: "Ustuvor",
        nextCustomerBadge: "NAVBATDAGI MIJOZ",
        noName: "Ismsiz mijoz",
        noPhone: "Telefon raqami yo'q",
        amount: "Miqdor",
        cylinderCount: "{{count}} ta ballon",
        payment: "To'lov",
        wentOnWay: "Yo'lga chiqdim",
        arrived: "Yetib keldim",
        serialPlaceholder: "Ballon seriya raqami (masalan: SG-88001-TX)",
        delivered: "Topshirdim",
        notFound: "Topilmadi",
        allDone: "Barcha buyurtmalar bajarildi!",
        nextInQueue: "Keyingi navbatdagilar",
        noOtherOrders: "Boshqa buyurtmalar yo'q",
        statusUpdated: "Holat yangilandi",
        routeStarted: "Marshrut boshlandi!",
        routeFinished: "Marshrut yakunlandi!",
      },
      operatorDashboard: {
        role: "Operator stansiyasi",
        pendingBadge: "{{count}} ta kutilayotgan buyurtma",
        titlePrefix: "Operator",
        titleSuffix: "Boshqaruv Paneli",
        subtitle: "Gaz tarqatish va buyurtmalarni tasdiqlash paneli",
        confirmTitle: "Tasdiqlash",
        qrLabel: "QR Kod yoki Token",
        qrConfirm: "QR orqali tasdiqlash",
        phoneLabel: "Telefon raqam",
        phoneConfirm: "Telefon orqali topish",
        serialLabel: "Ballon Seriyasi (Ixtiyoriy)",
        totalDelivered: "Jami topshirildi",
        queueTitle: "Navbatdagi mijozlar",
        emptyQueue: "Hozircha buyurtmalar yo'q",
        customer: "Mijoz",
        price: "Narxi",
        deliveredBtn: "Berildi",
        toastGasDelivered: "Gaz topshirildi!",
        toastQrConfirmed: "QR Tasdiqlandi!",
        toastOfflineNoInternet: "Internet yo'q. Ma'lumot offline saqlandi va keyinroq yuboriladi.",
        toastOfflineSaved: "Offline saqlandi",
        toastCompleted: "Muvaffaqiyatli yakunlandi",
        toastOfflineSynced: "{{count}} ta offline buyurtma sinxronizatsiya qilindi",
        cylinderUnit: "ballon",
      },
      adminRoutes: {
        loadError: "Ma'lumotlarni yuklashda xatolik",
        activated: "Yo'nalish faollashtirildi",
        driver: "Haydovchi",
        regions: "Hududlar",
        unassigned: "Belgilanmagan",
        logisticsMap: "Logistika xaritasi",
        mapLoading: "Interaktiv xarita yuklanmoqda",
        mapDesc: "Marshrutlar va haydovchilar joylashuvi shu yerda ko'rsatiladi",
      },
      adminTrucks: {
        loadError: "Ma'lumotlarni yuklashda xatolik",
        invalidPlateFormat: "Noto'g'ri davlat raqami formati! Namuna: 01 A 777 AA yoki 01 777 AAA",
        added: "Transport vositasi qo'shildi",
        updated: "Transport vositasi yangilandi",
        deleted: "Transport vositasi o'chirildi",
        confirmDeleteTitle: "O'CHIRISHNI TASDIQLASH",
        confirmDeleteDesc: "Haqiqatdan ham ushbu transport vositasini o'chirmoqchimisiz?",
        capacity: "Sig'imi",
        driver: "Haydovchi",
        unassigned: "Biriktirilmagan",
        addTitle: "YANGI TRANSPORT QO'SHISH",
        editTitle: "TRANSPORT VOSITASINI TAHRIRLASH",
        modelLabel: "Model nomi",
        plateLabel: "Davlat raqami",
        capacityLabel: "Sig'imi",
        driverLabel: "Haydovchi biriktirish",
        add: "Qo'shish",
        confirmDelete: "Ha, o'chirish",
        plateFormatHint: "Format: 01 A 777 AA yoki 01 777 AAA",
        modelPlaceholder: "Masalan: ISUZU NPR",
        driverPlaceholder: "Haydovchi tanlang (ixtiyoriy)",
        online: "ONLINE",
        offline: "OFFLINE",
      },
      adminStatistics: {
        noData: "Ma'lumot yo'q",
        revenue: "Daromad",
        orders: "Buyurtmalar",
      },
      adminPayments: {
        loadError: "To'lovlarni yuklashda xatolik",
      },
      adminQueue: {
        loadError: "Navbatni yuklashda xatolik",
      },
      adminCylinders: {
        loadError: "Ballonlarni yuklashda xatolik",
        created: "Yaratilgan",
        inStock: "Omborda",
      },
      settings: {
        title: "Sozlamalar",
        subtitle: "Profil va ilova ko'rinishini boshqaring",
        language: "Ilova tili",
        languageDesc: "Ilova tilini o'zingizga qulay formatga o'zgartiring",
        languages: {
          uzLatin: "O'zbek (Lotin)",
          uzCyrl: "Ўзбек (Кирилл)",
          ru: "Русский",
        },
        theme: "Ranglar mavzusi",
        themeDesc: "Ilova ko'rinishini yorug' yoki qorong'i rejimga o'tkazing",
        themeSystem: "Tizim",
        themeLight: "Yorug'",
        themeDark: "Qorong'i",
        activeSessions: "Faol sessiyalar",
        sessionsDesc: "Hisobingizga ulangan barcha qurilmalar",
        terminateOther: "Barchasini tugatish",
        noSessions: "Sessiyalar topilmadi",
        unknownDevice: "Noma'lum qurilma",
        current: "Joriy",
        terminateSession: "Sessiyani tugatish",
        copyright: "SmartGaz",
        confirmTerminateAll: "Barchasini tugatish?",
        confirmTerminateOne: "Sessiyani tugatish?",
        confirmTerminateAllDesc: "Joriy sessiyadan tashqari barcha qurilmalar tizimdan chiqariladi",
        confirmTerminateDeviceDesc: "\"{{device}}\" qurilmasi tizimdan chiqariladi",
        confirmTerminateOneDesc: "Ushbu qurilma tizimdan chiqariladi",
        confirmYes: "Ha, tugatish",
        sessionTerminated: "Sessiya tugatildi",
        otherSessionsTerminated: "Boshqa barcha sessiyalar tugatildi",
      },
      payment: {
        title: "To'lov",
        subtitle: "Hisobingizni to'ldiring va tranzaksiyalarni boshqaring",
        currentBalance: "Joriy balans",
        refillTitle: "Hisobni to'ldirish",
        amountLabel: "Summa",
        methodLabel: "To'lov usuli",
        payNow: "TO'LOVNI AMALGA OSHIRISH",
        historyTitle: "Tranzaksiyalar tarixi",
        historyEmpty: "Hali tranzaksiyalar yo'q",
        transactions: "tranzaksiya",
        status: {
          noDebt: "Qarzdorlik yo'q",
          hasDebt: "Qarzdorlik mavjud",
        },
        methods: {
          cash: "NAQD",
        },
        types: {
          topup: "HISOB TO'LDIRILDI",
          payment: "XARID UCHUN TO'LOV",
        },
        messages: {
          success: "To'lov muvaffaqiyatli amalga oshirildi!",
        },
        errors: {
          minAmount: "Miqdor kamida 1 000 so'm bo'lishi kerak",
          noCard: "Karta tanlanmagan",
          failed: "To'lov amalga oshirilmadi",
        }
      },
      profileModal: {
        title: "Profil",
        settings: "Sozlamalari",
        subtitle: "Shaxsiy ma'lumotlaringizni boshqaring",
        personalInfo: "Shaxsiy ma'lumotlar",
        userManagement: "Foydalanuvchilarni boshqarish",
        logout: "Tizimdan chiqish",
        user: "Foydalanuvchi",
        phone: "Telefon",
        role: "Rol",
        actions: "Amallar",
        selectMahalla: "Mahallangizni tanlang",
        errorInvalidImage: "Rasm formati noto'g'ri",
      },
      security: {
        title: "Xavfsizlik",
        subtitle: "Parol va xavfsizlik sozlamalarini boshqarish",
      },
      securityModal: {
        title: "Xavfsizlik",
        phoneHelp: "Parolni tiklash uchun telefon raqamingizni tasdiqlang",
        verification: "Tasdiqlash",
        codeSent: "raqamiga kod yuborildi",
        otpCode: "Tasdiqlash kodi",
        newPassword: "Yangi parol",
        passwordHelp: "Kamida 8 belgi, harflar va raqamlardan iborat bo'lishi kerak",
        errors: {
          password: "Parol kamida 6 ta belgidan iborat bo'lishi kerak",
        },
        confirmPassword: "Parolni tasdiqlang",
      },
      premium: {
        active: "FAOL",
        get: "PREMIUM OLISH",
        subtitle: "Barcha imkoniyatlardan cheksiz foydalaning",
      },
      common: {
        justNow: "Hozir",
        ago: "oldin",
        minutes: "daqiqa",
        hours: "soat",
        days: "kun",
        uzs: "so'm",
        save: "Saqlash",
        error: "Xatolik",
        failed: "Muvaffaqiyatsiz",
        processing: "Ishlov berilmoqda...",
        edit: "O'zgartirish",
        user: "Foydalanuvchi",
        confirmDelete: "O'chirishni tasdiqlaysizmi?",
        notification: "Xabar",
        you: "Siz",
        done: "Tayyor",
        submit: "Yuborish",
        cancel: "Bekor qilish",
        confirm: "Tasdiqlash",
        loading: "Yuklanmoqda",
        driver: "Haydovchi",
        status: "Holat",
        active: "Faol",
        inactive: "Nofaol",
        empty: "Bo'sh",
        details: "Batafsil",
        total: "Jami",
        max: "Maksimal",
        saving: "Saqlanmoqda...",
        close: "Yopish",
        pcs: "ta",
        update: "Yangilash",
        live: "Jonli",
        prev: "Oldingi",
        next: "Keyingi",
        pageOf: "{{page}}-sahifa / {{total}}",
        signingIn: "Tizimga kirilmoqda...",
        cylinders: "ballon",
      },
      setPassword: {
        title: "Parol O'rnatish",
        subtitle: "Google orqali kirdingiz. Endi akkauntingiz uchun parol o'rnating.",
        minLength: "Parol kamida 6 ta belgidan iborat bo'lishi kerak",
        tokenNotFound: "Token topilmadi, iltimos boshqatdan kiring.",
        genericError: "Xatolik yuz berdi",
        newPasswordLabel: "Yangi parol",
        submit: "Saqlash va Kirish",
      },
      mahallaSelector: {
        label: "Mahallangiz",
        placeholder: "Mahalla nomini yozing...",
        multipleMatches: "Bir nechta o'xshash mahalla — to'g'risini tanlang:",
        noMatches: "Mos mahalla topilmadi. Ro'yxatdan tanlang.",
      },
      lowBalanceAlert: {
        message: "Diqqat! Balansingiz kam qolgan: {{balance}}. Gaz yetkazib berish to'xtab qolmasligi uchun hisobni to'ldiring.",
        topUp: "To'ldirish",
      },
      createRouteModal: {
        title: "YANGI YO'NALISH YARATISH",
        subtitle: "Haydovchi va xizmat ko'rsatish hududlarini belgilang",
        step1: "1. Haydovchini tanlang",
        noDrivers: "Haydovchilar topilmadi.",
        step2: "2. Rejalashtirilgan sana",
        step3: "3. Mahalla qidirish",
        mahallaPlaceholder: "Mahalla nomi...",
        step4: "4. Hududlarni belgilang ({{count}})",
        clear: "Tozalash",
        noMahallas: "Mahallalar topilmadi",
        selectDriverError: "Haydovchini tanlang",
        selectMahallaError: "Kamida bitta mahallani tanlang",
        created: "Yo'nalish muvaffaqiyatli yaratildi",
        submit: "Yo'nalishni tasdiqlash",
      },
      billing: {
        balance: {
          current: "JORIY BALANS",
        },
        pay: {
          title: "Hisobni to'ldirish",
          currentDebt: "JORIY QARZDORLIK",
          amount: "TO'LOV SUMMASI",
          method: "TO'LOV USULI",
          selected: "karta tanlandi",
          confirm: "TO'LOVNI TASDIQLASH",
          addCard: "Yangi karta",
          errors: {
            failed: "To'lov amalga oshirilmadi",
          }
        },
        addCard: {
          title: "Karta Qo'shish",
          subtitle: "To'lov kartangizni ulang",
          pciNote: "Barcha ma'lumotlar xavfsiz va himoyalangan",
          fields: {
            cardNumber: "KARTA RAQAMI",
            expiry: "AMAL QILISH MUDDATI",
            cvv: "CVV/CVC",
            holder: "KARTA EGASI",
          },
          placeholders: {
            cardNumber: "0000 0000 0000 0000",
            expiry: "MM/YY",
            cvv: "000",
            holder: "ISM FAMILIYA",
          },
          errors: {
            cardNumber: "Karta raqami noto'g'ri",
            expiry: "Amal qilish muddati noto'g'ri",
            cvv: "CVV noto'g'ri",
            holder: "Ism juda qisqa",
          },
          save: "KARTANI SAQLASH",
        }
      },
      auth: {
        register: "Ro'yxatdan o'tish",
        login: "Kirish",
        phoneMode: "Telefon orqali",
        emailMode: "Email orqali",
        firstName: "Ism",
        lastName: "Familiya",
        phone: "Telefon raqami",
        email: "Email manzil",
        password: "Parol",
        submit: "Davom etish",
        back: "Orqaga",
        noAccount: "Hisobingiz yo'qmi?",
        hasAccount: "Hisobingiz bormi?",
        emailCode: "Email tasdiqlash",
        smsCode: "SMS tasdiqlash",
        resendCode: "Qayta yuborish",
        resendTimer: "Qayta yuborish",
        resetPassword: "Parolni tiklash",
        sentToPhone: "Telefon raqamingizga kod yuborildi",
        sentToEmail: "Email manzilingizga kod yuborildi",
        orDivider: "yoki",
        googleLogin: "Google orqali kirish",
        googleRegister: "Google orqali ro'yxatdan o'tish",
        mahallaTitle: "Mahalla",
        mahallaSubtitle: "Yashash mahallangizni yozing yoki ro'yxatdan tanlang",
        passwordsMismatch: "Parollar mos kelmaydi",
      },
      apiErrors: {
        PASSWORD_WEAK: "Parol juda oddiy. Kamida 8 belgi, katta harf va raqam ishlating.",
        USER_EXISTS: "Ushbu ma'lumotlarga ega foydalanuvchi allaqachon mavjud.",
        PHONE_ALREADY_EXISTS: "Ushbu telefon raqami allaqachon ro'yxatdan o'tgan.",
        EMAIL_ALREADY_EXISTS: "Ushbu email manzil allaqachon ro'yxatdan o'tgan.",
        INVALID_CREDENTIALS: "Login yoki parol noto'g'ri.",
        INTERNAL_ERROR: "Tizimda xatolik yuz berdi. Keyinroq qayta urinib ko'ring.",
        REQUEST_FAILED: "So'rov bajarilmadi.",
        AUTH_OTP_ERROR: "Tasdiqlash kodi noto'g'ri yoki muddati o'tgan.",
        INVALID_PHONE_FORMAT: "Telefon raqami formati noto'g'ri.",
        USER_NOT_VERIFIED: "Foydalanuvchi tasdiqlanmagan. Iltimos, hisobingizni tasdiqlang.",
        USER_BLOCKED: "Hisobingiz bloklangan",
        AUTH_LOGIN_ERROR: "Iltimos, majburiy maydonlarni to'ldiring",
      },
    },
  },
  uz_cyrl: {
    translation: {

      mainPage: {
        hello: "Салом",
        today: "Бугун",
        whereIsGas: "Газ Қаерда?",
        book: "Брон Қилиш",
        yourQueue: "Навбатингиз",
        balance: "Баланс",
        notifications: "Билдиришномалар",
        activeDelivery: "Фаол етказиш",
        gasDelivering: "ГАЗ ЕТКАЗИЛМОҚДА",
        viewQueue: "Навбатни кўриш"
      },
      premiumPanel: {
        title: "SmartGaz",
        premium: "Премиум",
        subtitle: "Янада кўпроқ имкониятлар ва қулайликларга эга бўлинг",
        fastQueue: "Тезкор Навбат",
        fastQueueDesc: "Навбатда доим биринчилардан бўлинг ва вақтингизни тежанг.",
        discounts: "Махсус Чегирмалар",
        discountsDesc: "Ҳар бир баллон учун 5% гача кешбек ва чегирмалар.",
        support: "24/7 Қўллаб-қувватлаш",
        supportDesc: "Сиз учун алоҳида менежер ва тезкор ёрдам хизмати.",
        statusPremium: "Сиз Премиум аъзосиз",
        statusNotPremium: "Ҳозироқ уланинг",
        activePremium: "Барча премиум имкониятлар сиз учун фаол",
        pricePremium: "Атиги 25 000 сўм / ойига",
        btnActive: "ФАОЛ",
        btnActivate: "ФАОЛЛАШТИРИШ",
        success: "SmartGaz Премиум муваффақиятли фаоллаштирилди!",
        alreadyActive: "Сизда аллақачон Премиум статус фаол!",
        error: "Фаоллаштиришда хатолик юз берди",
        insufficientBalance: "Баланс етарли эмас ёки бошқа хатолик"
      },
      smsCode: {
        title: "Паролни тиклаш",
        emailSubtitle: "Эмаил манзилингизни киритинг",
        sendCode: "Код юбориш",
        verifyCode: "Кодни тасдиқланг",
        resend: "Қайта юбориш",
        newPasswordTitle: "Янги парол",
        newPasswordSubtitle: "Кучли парол ўрнатинг",
        newPassword: "Янги парол",
        confirmPassword: "Паролни тасдиқланг",
        passwordsMismatch: "Пароллар мос келмайди",
        save: "Сақлаш",
        backToLogin: "Киришга қайтиш"
      },
      landing: {
        services: "Хизматлар",
        howItWorks: "Қандай ишлайди?",
        mobileApp: "Мобил илова",
        login: "Кириш",
        newLevelService: "Янги даражадаги хизмат",
        heroTitle: "Газ навбати энди телефонингизда",
        heroTitlePrefix: "Газ навбати энди",
        heroTitleHighlight: "телефонингизда",
        heroSubtitle: "SmartGaz орқали суюлтирилган газ баллонларига навбатга туринг, балансингизни назорат қилинг ва етказиб бериш вақтини кузатиб боринг.",
        joinQueue: "Навбатга туриш",
        downloadApp: "Иловани юклаш",
        queueArrived: "Навбат келди",
        cylinderReady: "Баллонингиз тайёр!",
        threeSteps: "3 оддий қадам",
        stepsSubtitle: "SmartGaz тизимидан фойдаланиш жуда осон ва қулай.",
        step1Title: "Рўйхатдан ўтинг",
        step1Desc: "Телефон рақамингиз орқали тизимга киринг.",
        step2Title: "Навбатга ёзилинг",
        step2Desc: "Бир тугма орқали электрон навбатга киринг.",
        step3Title: "Баллонни қабул қилинг",
        step3Desc: "Навбатингиз келганда газ баллонингизни кутиб олинг.",
        features: {
          realtime: "Реал вақтда",
          easyPayment: "Осон тўлов",
          history: "Тарих",
          support: "24/7 Ёрдам"
        },
        cabinetFeatures: "Шахсий кабинет имкониятлари",
        cabinetFeature1: "Газ баллонининг охирги санасини кузатиш",
        cabinetFeature2: "Маҳалла графикларини кўриш",
        cabinetFeature3: "Тезкор билдиришномалар",
        pricing: {
          title: "Нархлар",
          subtitle: "Ўзингизга мос таърифни танланг.",
          free: "Бепул (Free)",
          freeDesc: "Асосий имкониятлардан фойдаланиш учун",
          freePrice: "0 сўм",
          freeFeat1: "Электрон навбатга туриш",
          freeFeat2: "Асосий билдиришномалар",
          freeFeat3: "Профил созламалари",
          freeBtn: "Google орқали бошлаш",
          popular: "Энг машҳур",
          premium: "Премиум",
          premiumDesc: "Барча қулайликлар ва устуворликлар",
          premiumPrice: "15 000 сўм/ой",
          premiumFeat1: "Тезкор ва биринчи навбат",
          premiumFeat2: "24/7 устувор ёрдам",
          premiumFeat3: "Эксклюзив чегирмалар",
          premiumFeat4: "Батафсил тарих ва статистика",
          premiumBtn: "Премиумга ўтиш",
          perMonth: "ой"
        },
        download: {
          title: "Иловани юклаб олинг",
          subtitle: "Барча хизматлар энди бир қўл масофасида.",
          appStore: "Download on the App Store",
          googlePlay: "Get it on Google Play",
          ticket: "Навбат #12"
        },
        footer: {
          platform: "Рақамлаштириш платформаси.",
          servicesTitle: "Хизматлар",
          onlineQueue: "Онлайн Навбат",
          prices: "Нархлар",
          contactTitle: "Боғланиш"
        }
      },

      nav: {
        main: "Асосий",
        payment: "Тўловлар",
        queue: "Навбат",
        notifications: "Хабарлар",
        dashboard: "Бошқарув",
        statistics: "Статистика",
        users: "Фойдаланувчилар",
        trucks: "Юк машиналари",
        payments: "Тўловлар",
        cylinders: "Баллонлар",
        routes: "Йўналишлар",
        tracking: "Тракинг",
        orders: "Буюртмалар",
        premium: "Премиум",
        adminPanel: "Админ панел",
      },
      languageLabel: "Тилни алмаштириш",
      main: {
        welcome: "Хуш келибсиз,",
        subtitle: "Барча хизматлар ва маълумотлар бир жойда.",
        today: "Бугун",
        queueStatus: "Навбат ҳолати",
        inQueueStatus: "Навбатда",
        yourPosition: "Сизнинг ўрнингиз",
        minutesWait: "дақиқа кутилмоқда",
        leaveQueue: "Навбатдан чиқиш",
        leaveConfirm: "Навбатдан чиқишни тасдиқлайсизми?",
        queueJoinSuccess: "Навбатга муваффақиятли қўшилдингиз!",
        queueLeaveSuccess: "Навбатдан чиқдингиз",
        totalInQueue: "Жами навбатда",
        people: "киши",
        notInQueue: "Навбатда",
        notInQueueSuffix: "эмассиз",
        queueCta: "Газ баллонига буюртма беринг ва навбатга туринг",
        joinQueue: "Навбатга туриш",
        orders: "Буюртмалар",
        recentOrders: "Сўнгги буюртмалар",
        noOrders: "Ҳали буюртмалар йўқ",
        firstOrder: "Биринчи буюртма",
        orderType: "Баллон буюртмаси",
        recent: "Сўнгги ҳаракатлар",
        seeAll: "Барчаси",
        queueAction: "Навбатга туриш",
        chiptaRaqami: "Чипта #12",
        myOrders: "Буюртмаларим"
      },
      orderStatus: {
        PENDING: "Кутилмоқда",
        CONFIRMED: "Тасдиқланган",
        PREPARING: "Тайёрланмоқда",
        ON_WAY: "Йўлда",
        DELIVERED: "Етказилди",
        CANCELLED: "Бекор қилинган",
      },
      queuePage: {
        title: "Навбат",
        subtitle: "Реал вақт режимида навбатингизни кузатиб боринг",
        current: "Ҳозирги ҳолат",
        yourTurn: "Сизнинг навбатингиз",
        yourPosition: "Сизнинг ўрнингиз",
        left: "Олдингизда",
        eta: "Тахминий вақт",
        estimatedTime: "Тахминий вақт",
        etaValue: "~20 дақиқа",
        peopleCount: "5 киши",
        progress: "Навбат ривожи",
        ready: "Сизга яқин қолди, тайёр туринг!",
        refresh: "Янгилаш",
        cancel: "Бекор қилиш",
        leave: "Навбатни тарк этиш",
        join: "Навбатга туриш",
        premium: "Премиум тез навбат",
        helpText: "Саволларингиз борми?",
        helpLink: "Ёрдам бўлими",
        minutes: "дақиқа",
        currentStatus: "Ҳозирги ҳолат",
        orderStatus: "Буюртма ҳолати",
        listTitle: "Навбатдаги фойдаланувчилар",
        peopleWaiting: "киши кутилмоқда",
        listEmpty: "Ҳозирча навбатда ҳеч ким йўқ",
        next: "Кейинги",
        routeInfo: "Маршрут: {{status}} \u00b7 {{count}} маҳалла",
        status: {
          active: "Фаол",
        },
        messages: {
          joined: "Навбатга муваффақиятли қўшилдингиз!",
          left: "Навбатдан чиқдингиз",
        },
        emptyState: {
          title: "Навбатда эмассиз",
          subtitle: "Буюртма бериш орқали навбатга туришингиз мумкин"
        },
        steps: {
          created: { label: "Буюртма берилди", sub: "Сўров қабул қилинди" },
          confirmed: { label: "Тасдиқланди", sub: "Оператор тасдиқлади" },
          preparing: { label: "Тайёрланмоқда", sub: "Баллон тайёрланмоқда" },
          onWay: { label: "Йўлда", sub: "Курьер йўлга чиқди" },
          delivered: { label: "Етказилди", sub: "Буюртма якунланди" },
        }
      },
      tracking: {
        title: "Кузатиш",
        subtitle: "Баллон етказилишини реал вақтда кузатинг",
        driver: "Ҳайдовчи",
        vehicle: "Машина",
        status: "Ҳолат",
        eta: "Етиб келиш",
        call: "Қўнғироқ",
        location: "Манзил",
        callDriver: "Ҳайдовчига қўнғироқ",
        noActiveRoute: "Ҳозирча фаол кузатув йўқ",
        info: {
          orderId: "Буюртма ИД",
          estimatedTime: "Тахминий вақт",
          distance: "Масофа",
        }
      },
      support: {
        title: "Ёрдам",
        subtitle: "Муаммоларингизни ҳал қилиш учун марказ",
        sos: {
          title: "СОС",
          subtitle: "Фавқулодда вазиятларда тезкор хабар беринг",
          desc: "Хавфли вазият ёки газ сизиб чиқиши аниқланганда СОС тугмасини босинг.",
          button: "СОС ЮБОРИШ",
          confirm: "СОС юборишни тасдиқлайсизми?",
          success: "СОС хабари юборилди. Тез орада сиз билан боғланамиз.",
          error: "СОС юборишда хатолик юз берди",
        },
        faq: {
          title: "Кўп сўраладиган саволлар",
          delivery: {
            q: "Навбатга қандай туриш мумкин?",
            a: "Асосий саҳифадаги 'Навбатга туриш' тугмасини босинг."
          },
          debt: {
            q: "Тўлов қандай амалга оширилади?",
            a: "Тўловлар бўлимида CLICK, Payme ёки карта орқали тўлашингиз мумкин."
          },
          quality: {
            q: "Етказиб бериш қанча вақт олади?",
            a: "Одатда навбатингизга қараб 30 дақиқадан 2 соатгача."
          },
        },
        channels: {
          title: "Боғланиш каналлари",
          chat: { title: "Онлайн Чат", desc: "Оператор билан боғланиш" },
          call: { title: "Call Center", desc: "+998 71 200 00 00" },
          complaint: { title: "Шикоятлар", desc: "Сифат назорати" },
          email: { title: "Email", desc: "info@smartgaz.uz" },
        }
      },
      notifications: {
        title: "Хабарлар",
        subtitle: "Барча билдиришномалар ва янгиликлар",
        unread: "ўқилмаган",
        markAllRead: "Барчасини ўқилди деб белгилаш",
        empty: "Ҳали хабарлар йўқ",
        noUnread: "Барча хабарлар ўқилган",
        newOrder: "Янги буюртма қабул қилинди!",
        noUnreadItems: "Ўқилмаган хабар йўқ",
        emptyHint: "Янги хабарлар шу ерда кўринади",
      },
      dashboard: {
        title: "Бошқарув Панели",
        subtitle: "SmartGaz тизими реал-вақт мониторинги",
        createRoute: "Маршрут Яратиш",
        todayOrders: "Бугунги Буюртмалар",
        activeDrivers: "Фаол Ҳайдовчилар",
        pendingOrders: "Навбатдагилар",
        todayRevenue: "Бугунги Даромад",
        weeklyRevenue: "Ҳафталик Даромад",
        weeklyOrders: "Ҳафталик Буюртмалар",
        statisticsSubtitle: "Тизим кўрсаткичлари ва графиклар",
        last7Days: "Охирги 7 кун",
        cylindersSold: "Сотилган Баллонлар",
        volume: "Ҳажм",
        liveMonitoring: "Жонли Мониторинг",
        activeFleet: "фаол маршрут",
        activeFleetList: "Фаол Маршрутлар",
        noActiveFleet: "Ҳозирча фаол маршрутлар йўқ",
        lastCoords: "ОХИРГИ КООРД",
        quantity: "Миқдор",
        time: "Вақт",
        allRoutes: "Барча Маршрутлар",
        activateRoute: "Фаоллаштириш",
        completeRoute: "Якунлаш",
        routeActivated: "Маршрут фаоллаштирилди",
        routeCompleted: "Маршрут якунланди",
        userManagement: "Фойдаланувчилар бошқаруви",
        user: "Фойдаланувчи",
        role: "Рол",
        balance: "Баланс",
        status: "Статус",
        actions: "Амаллар",
        active: "Фаол",
        blocked: "Блокланган",
        enterNewBalance: "Янги балансни киритинг:",
        balanceUpdated: "Баланс янгиланди",
        userActivated: "Фойдаланувчи фаоллаштирилди",
        userBlocked: "Фойдаланувчи блокланди",
        errorLoadingUsers: "Фойдаланувчиларни юклашда хатолик",
        userInfoUpdated: "Фойдаланувчи маълумотлари янгиланди",
        quickSearch: "Тезкор қидирув...",
        updateBalanceTitle: "Балансни янгилаш",
        newBalanceAmount: "Янги баланс миқдори (UZS)",
        totalUsers: "Жами фойдаланувчилар",
        searchPlaceholder: "Қидириш...",
        lastSeen: "Охирги фаоллик",
        paymentManagement: "Тўловларни бошқариш",
        totalTransactions: "Жами транзакциялар",
        searchPayments: "Тўловларни қидириш...",
        date: "Сана",
        amount: "Сумма",
        type: "Тури",
        reason: "Сабаб",
        queueManagement: "Навбатни бошқариш",
        totalInQueue: "Навбатда жами",
        searchQueue: "Навбатдан қидириш...",
        orderID: "Буюртма ID",
        cylinders: "Баллонлар",
        totalPrice: "Умумий нарх",
        cylinderManagement: "Баллонларни бошқариш",
        totalCylinders: "Жами баллонлар",
        searchCylinders: "Баллонларни қидириш...",
        cylinderSerial: "Баллон серияси",
        capacity: "Сиғими",
        currentUser: "Жорий фойдаланувчи",
        lastFilled: "Охирги тўлдирилган",
        trucksManagement: "Транспорт парки",
        registeredTrucks: "Рўйхатдаги транспортлар",
        addTruck: "Янги транспорт",
        routesManagement: "Йўналишлар бошқаруви",
        activeRoutes: "Фаол йўналишлар",
        newRoute: "Янги йўналиш",
      },
      driverDashboard: {
        role: "Ҳайдовчи панели",
        gpsActive: "GPS фаол",
        gpsInactive: "GPS ўчиқ",
        titlePrefix: "Ҳайдовчи",
        titleSuffix: "Панели",
        subtitle: "Маршрут бошқаруви",
        startRoute: "Йўлга Чиқдим",
        gpsStop: "GPS Тўхтатиш",
        gpsStart: "GPS Ёқиш",
        gasFinished: "Газ Тугади",
        gasFinishedToast: "Газ тугагани ҳақида хабар юборилди",
        finishRoute: "Якунлаш",
        customerQueue: "Мижозлар Навбати",
        count: "{{count}} та",
        priority: "Устувор",
        nextCustomerBadge: "НАВБАТДАГИ МИЖОЗ",
        noName: "Исмсиз мижоз",
        noPhone: "Телефон рақами йўқ",
        amount: "Миқдор",
        cylinderCount: "{{count}} та баллон",
        payment: "Тўлов",
        wentOnWay: "Йўлга чиқдим",
        arrived: "Етиб келдим",
        serialPlaceholder: "Баллон серия рақами (масалан: SG-88001-TX)",
        delivered: "Топширдим",
        notFound: "Топилмади",
        allDone: "Барча буюртмалар бажарилди!",
        nextInQueue: "Кейинги навбатдагилар",
        noOtherOrders: "Бошқа буюртмалар йўқ",
        statusUpdated: "Ҳолат янгиланди",
        routeStarted: "Маршрут бошланди!",
        routeFinished: "Маршрут якунланди!",
      },
      operatorDashboard: {
        role: "Оператор станцияси",
        pendingBadge: "{{count}} та кутилаётган буюртма",
        titlePrefix: "Оператор",
        titleSuffix: "Бошқарув Панели",
        subtitle: "Газ тарқатиш ва буюртмаларни тасдиқлаш панели",
        confirmTitle: "Тасдиқлаш",
        qrLabel: "QR Код ёки Token",
        qrConfirm: "QR орқали тасдиқлаш",
        phoneLabel: "Телефон рақам",
        phoneConfirm: "Телефон орқали топиш",
        serialLabel: "Баллон Серияси (Ихтиёрий)",
        totalDelivered: "Жами топширилди",
        queueTitle: "Навбатдаги мижозлар",
        emptyQueue: "Ҳозирча буюртмалар йўқ",
        customer: "Мижоз",
        price: "Нархи",
        deliveredBtn: "Берилди",
        toastGasDelivered: "Газ топширилди!",
        toastQrConfirmed: "QR Тасдиқланди!",
        toastOfflineNoInternet: "Интернет йўқ. Маълумот offline сақланди ва кейинроқ юборилади.",
        toastOfflineSaved: "Offline сақланди",
        toastCompleted: "Муваффақиятли якунланди",
        toastOfflineSynced: "{{count}} та offline буюртма синхронизация қилинди",
        cylinderUnit: "баллон",
      },
      adminRoutes: {
        loadError: "Маълумотларни юклашда хатолик",
        activated: "Йўналиш фаоллаштирилди",
        driver: "Ҳайдовчи",
        regions: "Ҳудудлар",
        unassigned: "Белгиланмаган",
        logisticsMap: "Логистика харитаси",
        mapLoading: "Интерактив харита юкланмоқда",
        mapDesc: "Маршрутлар ва ҳайдовчилар жойлашуви шу ерда кўрсатилади",
      },
      adminTrucks: {
        loadError: "Маълумотларни юклашда хатолик",
        invalidPlateFormat: "Нотўғри давлат рақами формати! Намуна: 01 A 777 AA ёки 01 777 AAA",
        added: "Транспорт воситаси қўшилди",
        updated: "Транспорт воситаси янгиланди",
        deleted: "Транспорт воситаси ўчирилди",
        confirmDeleteTitle: "ЎЧИРИШНИ ТАСДИҚЛАШ",
        confirmDeleteDesc: "Ҳақиқатдан ҳам ушбу транспорт воситасини ўчирмоқчимисиз?",
        capacity: "Сиғими",
        driver: "Ҳайдовчи",
        unassigned: "Бириктирилмаган",
        addTitle: "ЯНГИ ТРАНСПОРТ ҚЎШИШ",
        editTitle: "ТРАНСПОРТ ВОСИТАСИНИ ТАҲРИРЛАШ",
        modelLabel: "Модель номи",
        plateLabel: "Давлат рақами",
        capacityLabel: "Сиғими",
        driverLabel: "Ҳайдовчи бириктириш",
        add: "Қўшиш",
        confirmDelete: "Ҳа, ўчириш",
        plateFormatHint: "Формат: 01 A 777 AA ёки 01 777 AAA",
        modelPlaceholder: "Масалан: ISUZU NPR",
        driverPlaceholder: "Ҳайдовчи танланг (ихтиёрий)",
        online: "ONLINE",
        offline: "OFFLINE",
      },
      adminStatistics: {
        noData: "Маълумот йўқ",
        revenue: "Даромад",
        orders: "Буюртмалар",
      },
      adminPayments: {
        loadError: "Тўловларни юклашда хатолик",
      },
      adminQueue: {
        loadError: "Навбатни юклашда хатолик",
      },
      adminCylinders: {
        loadError: "Баллонларни юклашда хатолик",
        created: "Яратилган",
        inStock: "Омборда",
      },
      settings: {
        title: "Созламалар",
        subtitle: "Профил ва илова кўринишини бошқаринг",
        language: "Илова тили",
        languageDesc: "Илова тилини ўзингизга қулай форматга ўзгартиринг",
        languages: {
          uzLatin: "O'zbek (Lotin)",
          uzCyrl: "Ўзбек (Кирилл)",
          ru: "Русский",
        },
        theme: "Ранглар мавзуси",
        themeDesc: "Илова кўринишини ёруғ ёки қоронғи режимга ўтказинг",
        themeSystem: "Тизим",
        themeLight: "Ёруғ",
        themeDark: "Қоронғи",
        activeSessions: "Фаол сессиялар",
        sessionsDesc: "Ҳисобингизга уланган барча қурилмалар",
        terminateOther: "Барчасини тугатиш",
        noSessions: "Сессиялар топилмади",
        unknownDevice: "Номаълум қурилма",
        current: "Жорий",
        terminateSession: "Сессияни тугатиш",
        copyright: "SmartGaz",
        confirmTerminateAll: "Барчасини тугатиш?",
        confirmTerminateOne: "Сессияни тугатиш?",
        confirmTerminateAllDesc: "Жорий сессиядан ташқари барча қурилмалар тизимдан чиқарилади",
        confirmTerminateDeviceDesc: "\"{{device}}\" қурилмаси тизимдан чиқарилади",
        confirmTerminateOneDesc: "Ушбу қурилма тизимдан чиқарилади",
        confirmYes: "Ҳа, тугатиш",
        sessionTerminated: "Сессия тугатилди",
        otherSessionsTerminated: "Бошқа барча сессиялар тугатилди",
      },
      payment: {
        title: "Тўлов",
        subtitle: "Ҳисобингизни тўлдиринг ва транзакцияларни бошқаринг",
        currentBalance: "Жорий баланс",
        refillTitle: "Ҳисобни тўлдириш",
        amountLabel: "Сумма",
        methodLabel: "Тўлов усули",
        payNow: "ТЎЛОВНИ АМАЛГА ОШИРИШ",
        historyTitle: "Транзакциялар тарихи",
        historyEmpty: "Ҳали транзакциялар йўқ",
        transactions: "транзакция",
        status: {
          noDebt: "Қарздорлик йўқ",
          hasDebt: "Қарздорлик мавжуд",
        },
        methods: {
          cash: "НАҚД",
        },
        types: {
          topup: "ҲИСОБ ТЎЛДИРИЛДИ",
          payment: "ХАРИД УЧУН ТЎЛОВ",
        },
        messages: {
          success: "Тўлов муваффақиятли амалга оширилди!",
        },
        errors: {
          minAmount: "Миқдор камида 1 000 сўм бўлиши керак",
          noCard: "Карта танланмаган",
          failed: "Тўлов амалга оширилмади",
        }
      },
      profileModal: {
        title: "Профил",
        settings: "Созламалари",
        subtitle: "Шахсий маълумотларингизни бошқаринг",
        personalInfo: "Шахсий маълумотлар",
        userManagement: "Фойдаланувчиларни бошқариш",
        logout: "Тизимдан чиқиш",
        user: "Фойдаланувчи",
        phone: "Телефон",
        role: "Рол",
        actions: "Амаллар",
        selectMahalla: "Маҳаллангизни танланг",
        errorInvalidImage: "Расм формати нотўғри",
      },
      security: {
        title: "Хавфсизлик",
        subtitle: "Парол ва хавфсизлик созламаларини бошқариш",
      },
      securityModal: {
        title: "Хавфсизлик",
        phoneHelp: "Паролни тиклаш учун телефон рақамингизни тасдиқланг",
        verification: "Тасдиқлаш",
        codeSent: "рақамига код юборилди",
        otpCode: "Тасдиқлаш коди",
        newPassword: "Янги парол",
        passwordHelp: "Камида 8 белги, ҳарфлар ва рақамлардан иборат бўлиши керак",
        errors: {
          password: "Парол камида 6 та белгидан иборат бўлиши керак",
        },
        confirmPassword: "Паролни тасдиқланг",
      },
      premium: {
        active: "ФАОЛ",
        get: "ПРЕМИУМ ОЛИШ",
        subtitle: "Барча имкониятлардан чексиз фойдаланинг",
      },
      common: {
        justNow: "Ҳозир",
        ago: "олдин",
        minutes: "дақиқа",
        hours: "соат",
        days: "кун",
        uzs: "сўм",
        save: "Сақлаш",
        error: "Хатолик",
        failed: "Муваффақиятсиз",
        processing: "Ишлов берилмоқда...",
        edit: "Ўзгартириш",
        user: "Фойдаланувчи",
        confirmDelete: "Ўчиришни тасдиқлайсизми?",
        notification: "Хабар",
        you: "Сиз",
        done: "Тайёр",
        submit: "Юбориш",
        cancel: "Бекор қилиш",
        confirm: "Тасдиқлаш",
        loading: "Юкланмоқда",
        driver: "Ҳайдовчи",
        status: "Ҳолат",
        active: "Фаол",
        inactive: "Нофаол",
        empty: "Бўш",
        details: "Батафсил",
        total: "Жами",
        max: "Максимал",
        saving: "Сақланмоқда...",
        close: "Ёпиш",
        pcs: "та",
        update: "Янгилаш",
        live: "Жонли",
        prev: "Олдинги",
        next: "Кейинги",
        pageOf: "{{page}}-саҳифа / {{total}}",
        signingIn: "Тизимга кирилмоқда...",
        cylinders: "баллон",
      },
      setPassword: {
        title: "Парол Ўрнатиш",
        subtitle: "Google орқали кирдингиз. Энди аккаунтингиз учун парол ўрнатинг.",
        minLength: "Парол камида 6 та белгидан иборат бўлиши керак",
        tokenNotFound: "Token топилмади, илтимос бошқатдан киринг.",
        genericError: "Хатолик юз берди",
        newPasswordLabel: "Янги парол",
        submit: "Сақлаш ва Кириш",
      },
      mahallaSelector: {
        label: "Маҳаллангиз",
        placeholder: "Маҳалла номини ёзинг...",
        multipleMatches: "Бир нечта ўхшаш маҳалла — тўғрисини танланг:",
        noMatches: "Мос маҳалла топилмади. Рўйхатдан танланг.",
      },
      lowBalanceAlert: {
        message: "Диққат! Балансингиз кам қолган: {{balance}}. Газ етказиб бериш тўхтаб қолмаслиги учун ҳисобни тўлдиринг.",
        topUp: "Тўлдириш",
      },
      createRouteModal: {
        title: "ЯНГИ ЙЎНАЛИШ ЯРАТИШ",
        subtitle: "Ҳайдовчи ва хизмат кўрсатиш ҳудудларини белгиланг",
        step1: "1. Ҳайдовчини танланг",
        noDrivers: "Ҳайдовчилар топилмади.",
        step2: "2. Режалаштирилган сана",
        step3: "3. Маҳалла қидириш",
        mahallaPlaceholder: "Маҳалла номи...",
        step4: "4. Ҳудудларни белгиланг ({{count}})",
        clear: "Тозалаш",
        noMahallas: "Маҳаллалар топилмади",
        selectDriverError: "Ҳайдовчини танланг",
        selectMahallaError: "Камида битта маҳаллани танланг",
        created: "Йўналиш муваффақиятли яратилди",
        submit: "Йўналишни тасдиқлаш",
      },
      billing: {
        balance: {
          current: "ЖОРИЙ БАЛАНС",
        },
        pay: {
          title: "Ҳисобни тўлдириш",
          currentDebt: "ЖОРИЙ ҚАРЗДОРЛИК",
          amount: "ТЎЛОВ СУММАСИ",
          method: "ТЎЛОВ УСУЛИ",
          selected: "карта танланди",
          confirm: "ТЎЛОВНИ ТАСДИҚЛАШ",
          addCard: "Янги карта",
          errors: {
            failed: "Тўлов амалга оширилмади",
          }
        },
        addCard: {
          title: "Карта Қўшиш",
          subtitle: "Тўлов картангизни уланг",
          pciNote: "Барча маълумотлар хавфсиз ва ҳимояланган",
          fields: {
            cardNumber: "КАРТА РАҚАМИ",
            expiry: "АМАЛ ҚИЛИШ МУДДАТИ",
            cvv: "CVV/CVC",
            holder: "КАРТА ЭГАСИ",
          },
          placeholders: {
            cardNumber: "0000 0000 0000 0000",
            expiry: "MM/YY",
            cvv: "000",
            holder: "ИСМ ФАМИЛИЯ",
          },
          errors: {
            cardNumber: "Карта рақами нотўғри",
            expiry: "Амал қилиш муддати нотўғри",
            cvv: "CVV нотўғри",
            holder: "Исм жуда қисқа",
          },
          save: "КАРТАНИ САҚЛАШ",
        }
      },
      auth: {
        register: "Рўйхатдан ўтиш",
        login: "Кириш",
        phoneMode: "Телефон орқали",
        emailMode: "Эмаил орқали",
        firstName: "Исм",
        lastName: "Фамилия",
        phone: "Телефон рақами",
        email: "Эмаил манзил",
        password: "Парол",
        submit: "Давом этиш",
        back: "Орқага",
        noAccount: "Ҳисобингиз йўқми?",
        hasAccount: "Ҳисобингиз борми?",
        emailCode: "Емаил тасдиқлаш",
        smsCode: "СМС тасдиқлаш",
        resendCode: "Қайта юбориш",
        resendTimer: "Қайта юбориш",
        resetPassword: "Паролни тиклаш",
        sentToPhone: "Телефон рақамингизга код юборилди",
        sentToEmail: "Емаил манзилингизга код юборилди",
        orDivider: "ёки",
        googleLogin: "Google орқали кириш",
        googleRegister: "Google орқали рўйхатдан ўтиш",
        mahallaTitle: "Маҳалла",
        mahallaSubtitle: "Яшаш маҳаллангизни ёзинг ёки рўйхатдан танланг",
        passwordsMismatch: "Пароллар мос келмайди",
      },
      apiErrors: {
        PASSWORD_WEAK: "Парол жуда оддий. Камида 8 белги, катта ҳарф ва рақам ишлатинг.",
        USER_EXISTS: "Ушбу маълумотларга эга фойдаланувчи аллақачон мавжуд.",
        PHONE_ALREADY_EXISTS: "Ушбу телефон рақами аллақачон рўйхатдан ўтган.",
        EMAIL_ALREADY_EXISTS: "Ушбу эмаил манзил аллақачон рўйхатдан ўтган.",
        INVALID_CREDENTIALS: "Логин ёки парол нотўғри.",
        INTERNAL_ERROR: "Тизимда хатолик юз берди. Кейинроқ қайта уриниб кўринг.",
        REQUEST_FAILED: "Сўров бажарилмади.",
        AUTH_OTP_ERROR: "Тасдиқлаш коди нотўғри ёки муддати ўтган.",
        INVALID_PHONE_FORMAT: "Телефон рақами формати нотўғри.",
        USER_NOT_VERIFIED: "Фойдаланувчи тасдиқланмаган. Илтимос, ҳисобингизни тасдиқланг.",
        USER_BLOCKED: "Ҳисобингиз блокланган",
        AUTH_LOGIN_ERROR: "Илтимос, мажбурий майдонларни тўлдиринг",
      },
    },
  },
  ru: {
    translation: {

      mainPage: {
        hello: "Привет",
        today: "Сегодня",
        whereIsGas: "Где Газ?",
        book: "Забронировать",
        yourQueue: "Ваша очередь",
        balance: "Баланс",
        notifications: "Уведомления",
        activeDelivery: "Активная доставка",
        gasDelivering: "ГАЗ ДОСТАВЛЯЕТСЯ",
        viewQueue: "Смотреть очередь"
      },
      premiumPanel: {
        title: "SmartGaz",
        premium: "Премиум",
        subtitle: "Получите еще больше возможностей и удобств",
        fastQueue: "Быстрая Очередь",
        fastQueueDesc: "Будьте всегда первыми в очереди и экономьте время.",
        discounts: "Специальные Скидки",
        discountsDesc: "До 5% кэшбэка и скидок на каждый баллон.",
        support: "Поддержка 24/7",
        supportDesc: "Персональный менеджер и служба быстрой помощи.",
        statusPremium: "Вы являетесь Премиум участником",
        statusNotPremium: "Подключитесь прямо сейчас",
        activePremium: "Все премиум-функции активны для вас",
        pricePremium: "Всего 25 000 сум / месяц",
        btnActive: "АКТИВЕН",
        btnActivate: "АКТИВИРОВАТЬ",
        success: "SmartGaz Premium успешно активирован!",
        alreadyActive: "У вас уже активен статус Премиум!",
        error: "Произошла ошибка при активации",
        insufficientBalance: "Недостаточно средств или другая ошибка"
      },
      smsCode: {
        title: "Сброс пароля",
        emailSubtitle: "Введите ваш email адрес",
        sendCode: "Отправить код",
        verifyCode: "Подтвердите код",
        resend: "Отправить повторно",
        newPasswordTitle: "Новый пароль",
        newPasswordSubtitle: "Установите надежный пароль",
        newPassword: "Новый пароль",
        confirmPassword: "Подтвердите пароль",
        passwordsMismatch: "Пароли не совпадают",
        save: "Сохранить",
        backToLogin: "Вернуться ко входу"
      },
      landing: {
        services: "Услуги",
        howItWorks: "Как это работает?",
        mobileApp: "Моб. приложение",
        login: "Войти",
        newLevelService: "Новый уровень сервиса",
        heroTitle: "Газовая очередь теперь в вашем телефоне",
        heroTitlePrefix: "Газовая очередь теперь в",
        heroTitleHighlight: "вашем телефоне",
        heroSubtitle: "Встаньте в очередь за сжиженным газом, контролируйте свой баланс и отслеживайте время доставки с помощью SmartGaz.",
        joinQueue: "Встать в очередь",
        downloadApp: "Скачать приложение",
        queueArrived: "Очередь подошла",
        cylinderReady: "Ваш баллон готов!",
        threeSteps: "3 простых шага",
        stepsSubtitle: "Использовать систему SmartGaz очень легко и удобно.",
        step1Title: "Зарегистрируйтесь",
        step1Desc: "Войдите в систему по номеру телефона.",
        step2Title: "Встаньте в очередь",
        step2Desc: "Присоединяйтесь к электронной очереди одной кнопкой.",
        step3Title: "Получите баллон",
        step3Desc: "Дождитесь газового баллона, когда подойдет ваша очередь.",
        features: {
          realtime: "В реальном времени",
          easyPayment: "Легкая оплата",
          history: "История",
          support: "Поддержка 24/7"
        },
        cabinetFeatures: "Возможности личного кабинета",
        cabinetFeature1: "Отслеживание даты выдачи баллона",
        cabinetFeature2: "Просмотр графиков махалли",
        cabinetFeature3: "Мгновенные уведомления",
        pricing: {
          title: "Цены",
          subtitle: "Выберите подходящий тариф.",
          free: "Бесплатно (Free)",
          freeDesc: "Для использования базовых возможностей",
          freePrice: "0 сум",
          freeFeat1: "Электронная очередь",
          freeFeat2: "Базовые уведомления",
          freeFeat3: "Настройки профиля",
          freeBtn: "Начать через Google",
          popular: "Самый популярный",
          premium: "Премиум",
          premiumDesc: "Все удобства и приоритеты",
          premiumPrice: "15 000 сум/мес",
          premiumFeat1: "Быстрая очередь без ожидания",
          premiumFeat2: "Приоритетная поддержка 24/7",
          premiumFeat3: "Эксклюзивные скидки",
          premiumFeat4: "Подробная история и статистика",
          premiumBtn: "Перейти на Премиум",
          perMonth: "мес"
        },
        download: {
          title: "Скачайте приложение",
          subtitle: "Все услуги теперь на расстоянии вытянутой руки.",
          appStore: "Download on the App Store",
          googlePlay: "Get it on Google Play",
          ticket: "Очередь #12"
        },
        footer: {
          platform: "Платформа цифровизации.",
          servicesTitle: "Услуги",
          onlineQueue: "Онлайн очередь",
          prices: "Цены",
          contactTitle: "Контакты"
        }
      },

      nav: {
        main: "Главная",
        payment: "Платежи",
        queue: "Очередь",
        notifications: "Сообщения",
        dashboard: "Панель",
        statistics: "Статистика",
        users: "Пользователи",
        trucks: "Грузовики",
        payments: "Платежи",
        cylinders: "Баллоны",
        routes: "Маршруты",
        tracking: "Трекинг",
        orders: "Заказы",
        premium: "Премиум",
        adminPanel: "Админ-панель",
      },
      languageLabel: "Сменить язык",
      billing: {
        balance: {
          current: "ТЕКУЩИЙ БАЛАНС",
        },
        pay: {
          title: "Пополнение счета",
          currentDebt: "ТЕКУЩАЯ ЗАДОЛЖЕННОСТЬ",
          amount: "СУММА ОПЛАТЫ",
          method: "СПОСОБ ОПЛАТЫ",
          selected: "карта выбрана",
          confirm: "ПОДТВЕРДИТЬ ОПЛАТУ",
          addCard: "Новая карта",
          errors: {
            failed: "Платеж не удался",
          }
        },
        addCard: {
          title: "Добавить Карту",
          subtitle: "Привяжите вашу платежную карту",
          pciNote: "Все данные зашифрованы и защищены",
          fields: {
            cardNumber: "НОМЕР КАРТЫ",
            expiry: "СРОК ДЕЙСТВИЯ",
            cvv: "CVV/CVC",
            holder: "ВЛАДЕЛЕЦ КАРТЫ",
          },
          placeholders: {
            cardNumber: "0000 0000 0000 0000",
            expiry: "ММ/ГГ",
            cvv: "000",
            holder: "ИМЯ ФАМИЛИЯ",
          },
          errors: {
            cardNumber: "Неверный номер карты",
            expiry: "Неверный срок действия",
            cvv: "Неверный CVV",
            holder: "Слишком короткое имя",
          },
          save: "СОХРАНИТЬ КАРТУ",
        }
      },
      main: {
        welcome: "Добро пожаловать,",
        subtitle: "Все сервисы и данные в одном месте.",
        today: "Сегодня",
        queueStatus: "Статус очереди",
        inQueueStatus: "В очереди",
        yourPosition: "Ваша позиция",
        minutesWait: "минут ожидания",
        leaveQueue: "Выйти из очереди",
        leaveConfirm: "Вы уверены, что хотите выйти из очереди?",
        queueJoinSuccess: "Вы успешно встали в очередь!",
        queueLeaveSuccess: "Вы вышли из очереди",
        totalInQueue: "Всего в очереди",
        people: "человек",
        notInQueue: "Вы не",
        notInQueueSuffix: "в очереди",
        queueCta: "Закажите газовый баллон и встаньте в очередь",
        joinQueue: "Встать в очередь",
        orders: "Заказы",
        recentOrders: "Последние заказы",
        noOrders: "Заказов пока нет",
        firstOrder: "Первый заказ",
        orderType: "Заказ баллона",
        recent: "Последние действия",
        seeAll: "Все",
        queueAction: "Встать в очередь",
        chiptaRaqami: "Билет #12",
        myOrders: "Мои заказы"
      },
      orderStatus: {
        PENDING: "Ожидание",
        CONFIRMED: "Подтверждено",
        PREPARING: "Подготовка",
        ON_WAY: "В пути",
        DELIVERED: "Доставлено",
        CANCELLED: "Отменено",
      },
      dashboard: {
        title: "Панель управления",
        subtitle: "Мониторинг системы SmartGaz в реальном времени",
        createRoute: "Создать маршрут",
        todayOrders: "Заказы сегодня",
        activeDrivers: "Активные водители",
        pendingOrders: "В очереди",
        todayRevenue: "Выручка сегодня",
        weeklyRevenue: "Еженедельная выручка",
        weeklyOrders: "Еженедельные заказы",
        statisticsSubtitle: "Показатели системы и графики",
        last7Days: "Последние 7 дней",
        cylindersSold: "Проданные баллоны",
        volume: "Объем",
        liveMonitoring: "Живой мониторинг",
        activeFleet: "активный маршрут",
        activeFleetList: "Активные маршруты",
        noActiveFleet: "Пока нет активных маршрутов",
        lastCoords: "ПОСЛЕДНИЕ КООРД",
        quantity: "Количество",
        time: "Время",
        allRoutes: "Все маршруты",
        activateRoute: "Активировать",
        completeRoute: "Завершить",
        routeActivated: "Маршрут активирован",
        routeCompleted: "Маршрут завершен",
        userManagement: "Управление пользователями",
        user: "Пользователь",
        role: "Роль",
        balance: "Баланс",
        status: "Статус",
        actions: "Действия",
        active: "Активен",
        blocked: "Заблокирован",
        enterNewBalance: "Введите новый баланс:",
        balanceUpdated: "Баланс обновлен",
        userActivated: "Пользователь активирован",
        userBlocked: "Пользователь заблокирован",
        errorLoadingUsers: "Ошибка при загрузке пользователей",
        userInfoUpdated: "Данные пользователя обновлены",
        quickSearch: "Быстрый поиск...",
        updateBalanceTitle: "Обновить баланс",
        newBalanceAmount: "Новая сумма баланса (UZS)",
        totalUsers: "Всего пользователей",
        searchPlaceholder: "Поиск...",
        lastSeen: "Последняя активность",
        paymentManagement: "Управление платежами",
        totalTransactions: "Всего транзакций",
        searchPayments: "Поиск платежей...",
        date: "Дата",
        amount: "Сумма",
        type: "Тип",
        reason: "Причина",
        queueManagement: "Управление очередью",
        totalInQueue: "Всего в очереди",
        searchQueue: "Поиск в очереди...",
        orderID: "ID заказа",
        cylinders: "Баллоны",
        totalPrice: "Итоговая цена",
        cylinderManagement: "Управление баллонами",
        totalCylinders: "Всего баллонов",
        searchCylinders: "Поиск баллонов...",
        cylinderSerial: "Серия баллона",
        capacity: "Вместимость",
        currentUser: "Текущий пользователь",
        lastFilled: "Последнее наполнение",
        trucksManagement: "Автопарк",
        registeredTrucks: "Зарегистрированные машины",
        addTruck: "Новый транспорт",
        routesManagement: "Управление маршрутами",
        activeRoutes: "Активные маршруты",
        newRoute: "Новый маршрут",
      },
      driverDashboard: {
        role: "Панель водителя",
        gpsActive: "GPS активен",
        gpsInactive: "GPS выключен",
        titlePrefix: "Панель",
        titleSuffix: "Водителя",
        subtitle: "Управление маршрутом",
        startRoute: "Выехал",
        gpsStop: "Остановить GPS",
        gpsStart: "Включить GPS",
        gasFinished: "Газ закончился",
        gasFinishedToast: "Сообщение об окончании газа отправлено",
        finishRoute: "Завершить",
        customerQueue: "Очередь клиентов",
        count: "{{count}} шт",
        priority: "Приоритет",
        nextCustomerBadge: "СЛЕДУЮЩИЙ КЛИЕНТ",
        noName: "Клиент без имени",
        noPhone: "Нет номера телефона",
        amount: "Количество",
        cylinderCount: "{{count}} баллон(ов)",
        payment: "Оплата",
        wentOnWay: "Выехал",
        arrived: "Прибыл",
        serialPlaceholder: "Серийный номер баллона (например: SG-88001-TX)",
        delivered: "Доставил",
        notFound: "Не найден",
        allDone: "Все заказы выполнены!",
        nextInQueue: "Следующие в очереди",
        noOtherOrders: "Других заказов нет",
        statusUpdated: "Статус обновлен",
        routeStarted: "Маршрут начат!",
        routeFinished: "Маршрут завершен!",
      },
      operatorDashboard: {
        role: "Операторская станция",
        pendingBadge: "{{count}} заказ(ов) в ожидании",
        titlePrefix: "Оператор",
        titleSuffix: "Панель управления",
        subtitle: "Панель распределения газа и подтверждения заказов",
        confirmTitle: "Подтверждение",
        qrLabel: "QR-код или Token",
        qrConfirm: "Подтвердить по QR",
        phoneLabel: "Номер телефона",
        phoneConfirm: "Найти по телефону",
        serialLabel: "Серия баллона (необязательно)",
        totalDelivered: "Всего выдано",
        queueTitle: "Клиенты в очереди",
        emptyQueue: "Заказов пока нет",
        customer: "Клиент",
        price: "Цена",
        deliveredBtn: "Выдано",
        toastGasDelivered: "Газ выдан!",
        toastQrConfirmed: "QR подтвержден!",
        toastOfflineNoInternet: "Нет интернета. Данные сохранены offline и будут отправлены позже.",
        toastOfflineSaved: "Сохранено offline",
        toastCompleted: "Успешно завершено",
        toastOfflineSynced: "{{count}} offline-заказ(ов) синхронизировано",
        cylinderUnit: "баллон",
      },
      adminRoutes: {
        loadError: "Ошибка при загрузке данных",
        activated: "Маршрут активирован",
        driver: "Водитель",
        regions: "Районы",
        unassigned: "Не назначено",
        logisticsMap: "Логистическая карта",
        mapLoading: "Интерактивная карта загружается",
        mapDesc: "Здесь будут отображаться маршруты и расположение водителей",
      },
      adminTrucks: {
        loadError: "Ошибка при загрузке данных",
        invalidPlateFormat: "Неверный формат гос. номера! Пример: 01 A 777 AA или 01 777 AAA",
        added: "Транспортное средство добавлено",
        updated: "Транспортное средство обновлено",
        deleted: "Транспортное средство удалено",
        confirmDeleteTitle: "ПОДТВЕРДИТЕ УДАЛЕНИЕ",
        confirmDeleteDesc: "Вы действительно хотите удалить это транспортное средство?",
        capacity: "Вместимость",
        driver: "Водитель",
        unassigned: "Не назначен",
        addTitle: "ДОБАВИТЬ ТРАНСПОРТ",
        editTitle: "РЕДАКТИРОВАТЬ ТРАНСПОРТ",
        modelLabel: "Название модели",
        plateLabel: "Гос. номер",
        capacityLabel: "Вместимость",
        driverLabel: "Назначить водителя",
        add: "Добавить",
        confirmDelete: "Да, удалить",
        plateFormatHint: "Формат: 01 A 777 AA или 01 777 AAA",
        modelPlaceholder: "Например: ISUZU NPR",
        driverPlaceholder: "Выберите водителя (необязательно)",
        online: "ONLINE",
        offline: "OFFLINE",
      },
      adminStatistics: {
        noData: "Нет данных",
        revenue: "Выручка",
        orders: "Заказы",
      },
      adminPayments: {
        loadError: "Ошибка при загрузке платежей",
      },
      adminQueue: {
        loadError: "Ошибка при загрузке очереди",
      },
      adminCylinders: {
        loadError: "Ошибка при загрузке баллонов",
        created: "Создан",
        inStock: "На складе",
      },
      queuePage: {
        title: "Очередь",
        subtitle: "Следите за вашей очередью в реальном времени",
        current: "Текущее состояние",
        yourTurn: "Ваш номер в очереди",
        yourPosition: "Ваша позиция",
        left: "Перед вами",
        eta: "Примерное время",
        estimatedTime: "Примерное время",
        etaValue: "~20 минут",
        peopleCount: "5 человек",
        progress: "Прогресс очереди",
        ready: "Вы почти у цели, будьте готовы!",
        refresh: "Обновить",
        cancel: "Отменить",
        leave: "Покинуть очередь",
        join: "Встать в очередь",
        premium: "Премиум быстрая очередь",
        helpText: "Есть вопросы?",
        helpLink: "Раздел помощи",
        minutes: "минут",
        currentStatus: "Текущее состояние",
        orderStatus: "Статус заказа",
        listTitle: "Пользователи в очереди",
        peopleWaiting: "человек ожидают",
        listEmpty: "В очереди пока никого нет",
        next: "Следующий",
        routeInfo: "Маршрут: {{status}} \u00b7 {{count}} махаллей",
        status: {
          active: "Активен",
        },
        messages: {
          joined: "Вы успешно встали в очередь!",
          left: "Вы вышли из очереди",
        },
        emptyState: {
          title: "Вы не в очереди",
          subtitle: "Вы можете встать в очередь, сделав заказ"
        },
        steps: {
          created: { label: "Заказ сделан", sub: "Запрос принят" },
          confirmed: { label: "Подтверждено", sub: "Оператор подтвердил" },
          preparing: { label: "Подготовка", sub: "Баллон готовится" },
          onWay: { label: "В пути", sub: "Курьер выехал" },
          delivered: { label: "Доставлено", sub: "Заказ завершен" },
        }
      },
      tracking: {
        title: "Отслеживание",
        subtitle: "Следите за доставкой баллона в реальном времени",
        driver: "Водитель",
        vehicle: "Машина",
        status: "Статус",
        eta: "Прибытие",
        call: "Позвонить",
        location: "Местоположение",
        callDriver: "Позвонить водителю",
        noActiveRoute: "Активного отслеживания пока нет",
        info: {
          orderId: "ИД заказа",
          estimatedTime: "Примерное время",
          distance: "Расстояние",
        }
      },
      support: {
        title: "Помощь",
        subtitle: "Центр решения ваших проблем",
        sos: {
          title: "SOS",
          subtitle: "Сообщите о чрезвычайной ситуации",
          desc: "Нажмите кнопку SOS при обнаружении опасной ситуации или утечки газа.",
          button: "ОТПРАВИТЬ SOS",
          confirm: "Вы уверены, что хотите отправить SOS?",
          success: "Сообщение SOS отправлено. Мы скоро свяжемся с вами.",
          error: "Ошибка при отправке SOS",
        },
        faq: {
          title: "Часто задаваемые вопросы",
          delivery: {
            q: "Как встать в очередь?",
            a: "Нажмите кнопку 'Встать в очередь' на главной странице."
          },
          debt: {
            q: "Как производится оплата?",
            a: "Вы можете оплатить через CLICK, Payme или картой в разделе платежей."
          },
          quality: {
            q: "Сколько времени занимает доставка?",
            a: "Обычно от 30 минут до 2 часов, в зависимости от вашей очереди."
          },
        },
        channels: {
          title: "Каналы связи",
          chat: { title: "Онлайн Чат", desc: "Связь с оператором" },
          call: { title: "Call Center", desc: "+998 71 200 00 00" },
          complaint: { title: "Жалобы", desc: "Контроль качества" },
          email: { title: "Email", desc: "info@smartgaz.uz" },
        }
      },
      notifications: {
        title: "Сообщения",
        subtitle: "Все уведомления и новости",
        unread: "непрочитано",
        markAllRead: "Отметить все как прочитанные",
        empty: "Сообщений пока нет",
        noUnread: "Все сообщения прочитаны",
        newOrder: "Принят новый заказ!",
        noUnreadItems: "Нет непрочитанных сообщений",
        emptyHint: "Новые сообщения будут отображаться здесь",
      },
      settings: {
        title: "Настройки",
        subtitle: "Управляйте профилем и внешним видом приложения",
        language: "Язык приложения",
        languageDesc: "Измените язык приложения на удобный для вас формат",
        languages: {
          uzLatin: "O'zbek (Lotin)",
          uzCyrl: "Ўзбек (Кирилл)",
          ru: "Русский",
        },
        theme: "Цветовая тема",
        themeDesc: "Переключите внешний вид приложения на светлый или темный режим",
        themeSystem: "Система",
        themeLight: "Светлая",
        themeDark: "Темная",
        activeSessions: "Активные сессии",
        sessionsDesc: "Все устройства, подключенные к вашему аккаунту",
        terminateOther: "Завершить все",
        noSessions: "Сессии не найдены",
        unknownDevice: "Неизвестное устройство",
        current: "Текущая",
        terminateSession: "Завершить сессию",
        copyright: "SmartGaz",
        confirmTerminateAll: "Завершить все?",
        confirmTerminateOne: "Завершить сессию?",
        confirmTerminateAllDesc: "Все устройства, кроме текущей сессии, будут отключены от аккаунта",
        confirmTerminateDeviceDesc: "Устройство \"{{device}}\" будет отключено от аккаунта",
        confirmTerminateOneDesc: "Это устройство будет отключено от аккаунта",
        confirmYes: "Да, завершить",
        sessionTerminated: "Сессия завершена",
        otherSessionsTerminated: "Все остальные сессии завершены",
      },
      payment: {
        title: "Оплата",
        subtitle: "Пополняйте баланс и управляйте транзакциями",
        currentBalance: "Текущий баланс",
        refillTitle: "Пополнение счета",
        amountLabel: "Сумма",
        methodLabel: "Способ оплаты",
        payNow: "СОВЕРШИТЬ ОПЛАТУ",
        historyTitle: "История транзакций",
        historyEmpty: "Транзакций пока нет",
        transactions: "транзакция",
        status: {
          noDebt: "Нет задолженности",
          hasDebt: "Есть задолженность",
        },
        methods: {
          cash: "НАЛИЧНЫМИ",
        },
        types: {
          topup: "ПОПОЛНЕНИЕ СЧЕТА",
          payment: "ОПЛАТА ПОКУПКИ",
        },
        messages: {
          success: "Оплата успешно выполнена!",
        },
        errors: {
          minAmount: "Сумма должна быть не менее 1 000 сум",
          noCard: "Карта не выбрана",
          failed: "Платеж не удался",
        }
      },
      profileModal: {
        title: "Профиль",
        settings: "Настройки",
        subtitle: "Управляйте вашими личными данными",
        personalInfo: "Личные данные",
        userManagement: "Управление пользователями",
        logout: "Выйти из системы",
        user: "Пользователь",
        phone: "Телефон",
        role: "Роль",
        actions: "Действия",
        selectMahalla: "Выберите вашу махаллю",
        errorInvalidImage: "Неверный формат изображения",
      },
      security: {
        title: "Безопасность",
        subtitle: "Управление паролем и настройками безопасности",
      },
      securityModal: {
        title: "Безопасность",
        phoneHelp: "Подтвердите номер телефона для сброса пароля",
        verification: "Подтверждение",
        codeSent: "на этот номер отправлен код",
        otpCode: "Код подтверждения",
        newPassword: "Новый пароль",
        passwordHelp: "Должен состоять минимум из 8 символов, букв и цифр",
        errors: {
          password: "Пароль должен содержать минимум 6 символов",
        },
        confirmPassword: "Подтвердите пароль",
      },
      premium: {
        active: "АКТИВЕН",
        get: "ПОЛУЧИТЬ PREMIUM",
        subtitle: "Используйте все возможности без ограничений",
      },
      common: {
        justNow: "Только что",
        ago: "назад",
        minutes: "минут",
        hours: "часов",
        days: "дней",
        uzs: "сум",
        save: "Сохранить",
        cancel: "Отмена",
        confirm: "Подтвердить",
        loading: "Загрузка",
        driver: "Водитель",
        status: "Статус",
        active: "Активен",
        inactive: "Неактивен",
        empty: "Пусто",
        details: "Подробнее",
        total: "Всего",
        max: "Макс.",
        processing: "Обработка...",
        edit: "Изменить",
        user: "Пользователь",
        confirmDelete: "Вы уверены, что хотите удалить?",
        notification: "Уведомление",
        you: "Вы",
        done: "Готово",
        update: "Обновить",
        live: "Live",
        prev: "Назад",
        next: "Далее",
        pageOf: "Стр. {{page}} / {{total}}",
        signingIn: "Выполняется вход...",
        cylinders: "баллон(ов)",
        saving: "Сохранение...",
        close: "Закрыть",
        pcs: "шт.",
        submit: "Отправить",
      },
      setPassword: {
        title: "Установка пароля",
        subtitle: "Вы вошли через Google. Теперь установите пароль для вашего аккаунта.",
        minLength: "Пароль должен содержать минимум 6 символов",
        tokenNotFound: "Token не найден, пожалуйста, войдите снова.",
        genericError: "Произошла ошибка",
        newPasswordLabel: "Новый пароль",
        submit: "Сохранить и войти",
      },
      mahallaSelector: {
        label: "Ваша махалля",
        placeholder: "Введите название махалли...",
        multipleMatches: "Найдено несколько похожих махаллей — выберите нужную:",
        noMatches: "Подходящая махалля не найдена. Выберите из списка.",
      },
      lowBalanceAlert: {
        message: "Внимание! У вас низкий баланс: {{balance}}. Пополните счет, чтобы доставка газа не прервалась.",
        topUp: "Пополнить",
      },
      createRouteModal: {
        title: "СОЗДАТЬ НОВЫЙ МАРШРУТ",
        subtitle: "Назначьте водителя и зоны обслуживания",
        step1: "1. Выберите водителя",
        noDrivers: "Водители не найдены.",
        step2: "2. Запланированная дата",
        step3: "3. Поиск махалли",
        mahallaPlaceholder: "Название махалли...",
        step4: "4. Отметьте зоны ({{count}})",
        clear: "Очистить",
        noMahallas: "Махалли не найдены",
        selectDriverError: "Выберите водителя",
        selectMahallaError: "Выберите хотя бы одну махаллю",
        created: "Маршрут успешно создан",
        submit: "Подтвердить маршрут",
      },
      auth: {
        register: "Регистрация",
        login: "Вход",
        phoneMode: "По телефону",
        emailMode: "По Email",
        firstName: "Имя",
        lastName: "Фамилия",
        phone: "Номер телефона",
        email: "Электронная почта",
        password: "Пароль",
        submit: "Продолжить",
        back: "Назад",
        noAccount: "Нет аккаунта?",
        hasAccount: "Есть аккаунт?",
        emailCode: "Подтверждение Email",
        smsCode: "Подтверждение SMS",
        resendCode: "Отправить повторно",
        resendTimer: "Отправить повторно через",
        resetPassword: "Сброс пароля",
        sentToPhone: "Код отправлен на ваш номер телефона",
        sentToEmail: "Код отправлен на ваш Email",
        orDivider: "или",
        googleLogin: "Войти через Google",
        googleRegister: "Зарегистрироваться через Google",
        mahallaTitle: "Махалля",
        mahallaSubtitle: "Введите вашу махаллю или выберите из списка",
        passwordsMismatch: "Пароли не совпадают",
      },
      apiErrors: {
        PASSWORD_WEAK: "Пароль слишком простой. Используйте минимум 8 символов, заглавную букву и цифру.",
        USER_EXISTS: "Пользователь с такими данными уже существует.",
        PHONE_ALREADY_EXISTS: "Этот номер телефона уже зарегистрирован.",
        EMAIL_ALREADY_EXISTS: "Этот адрес электронной почты уже зарегистрирован.",
        INVALID_CREDENTIALS: "Неверный логин или пароль.",
        INTERNAL_ERROR: "Произошла системная ошибка. Попробуйте позже.",
        REQUEST_FAILED: "Ошибка запроса.",
        AUTH_OTP_ERROR: "Код подтверждения неверен или истек.",
        INVALID_PHONE_FORMAT: "Неверный формат номера телефона.",
        USER_NOT_VERIFIED: "Пользователь не подтвержден. Пожалуйста, подтвердите ваш аккаунт.",
        USER_BLOCKED: "Ваш аккаунт заблокирован",
        AUTH_LOGIN_ERROR: "Пожалуйста, заполните обязательные поля",
      },
    },
  },
}
const savedLang = localStorage.getItem("app_language");
const initialLanguage = ["uz_latin", "uz_cyrl", "ru"].includes(savedLang) ? savedLang : "uz_cyrl";

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: "uz_cyrl",
  interpolation: {
    escapeValue: false,
  },
  // Missing keys must resolve to "" (falsy) instead of the raw key string,
  // so existing `t('x.y') || 'fallback text'` call sites degrade to their
  // fallback instead of leaking keys like "SETTINGS.LANGUAGE" into the UI.
  parseMissingKeyHandler: () => "",
});

export default i18n;
